
      <div class="row">
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Pending RFQs</h4>
              <h2 class="text-end"><span class="float-start">{{ pendingRfqs }}</span><i class="fas fa-ticket-alt"></i></h2>
              <p class="m-b-0">Navigate To Pending RFQs</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Approved RFQs</h4>
              <h2 class="text-end"><span class="float-start">{{ approvedRfqs }}</span><i class="far fa-check-circle"></i></h2>
              <p class="m-b-0">Navigate To Approved RFQs</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Posted RFQs</h4>
              <h2 class="text-end"><span class="float-start">{{ postedRfqs }}</span><i class="fas fa-briefcase"></i></h2>
              <p class="m-b-0">Navigate To Posted RFQs</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Rejected RFQs</h4>
              <h2 class="text-end"><span class="float-start">{{ rejectedRfqs }}</span><i class="fas fa-umbrella-beach"></i></h2>
              <p class="m-b-0">Rejected RFQs</p>
            </div>
          </div>
        </div>
      </div>
      
     
    